// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1Oonf","icon":"SortAdornment_icon__paB-r","up":"SortAdornment_up__b-Au0","down":"SortAdornment_down__5Urek","active":"SortAdornment_active__2wNBK"};